/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { useMutation } from 'react-query';
import { saveFile } from '../api-action';

const useSaveFile = () => {
  return useMutation(saveFile);
};

export default useSaveFile;
